// extracted by mini-css-extract-plugin
module.exports = {"toggle":"NavToggle_toggle__dGRuZ","inner":"NavToggle_inner__Mz7wV","icon":"NavToggle_icon__lYNge"};